import { dataPenWrite } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPenWrite = /*#__PURE__*/createIcon(dataPenWrite)
export default IconPenWrite
